const X_WIZARD_SESSION_TOKEN = 'x-wizard-session-token';

export { X_WIZARD_SESSION_TOKEN };
